import { compose } from 'redux';
import { connect } from 'react-redux';
import DazeModelView from './DazeModelView';
import selectors from '../../../rootSelectors';
import { fetchDazeContent, clearResponses } from '../../dazeActions';
import { setAvatarInstructions } from '../../../common/avatar/avatarActions';
import AvatarView from '../../../common/avatar/avatarView';
import { DAZE_INSTRUCTIONS } from '../../dazeConstants';
import { stopAudio } from '../../../common/audio/audioActions';
import {
    unmountScreen, blockScreen, unblockScreen, colorInScreen, greyOutScreen,
} from '../../../common/screen/screenActions';
import { onResponseSelected, playDirectionsScript, playModelScript } from './DazeModelActions';
import { MODEL } from '../../../constants/assessmentItemType';
import { goToPractice } from '../../../common/navigation/navigationActions';
import { DAZE } from '../../../constants/measure';
import withAvatar from '../../../common/avatar/withAvatar';

const INSTRUCTIONS = DAZE_INSTRUCTIONS[MODEL];

const mapStateToProps = (state) => ({
    isScreenBlocked: selectors.getIsScreenBlocked(state),
    isNextButtonActive: selectors.getIsNextButtonActive(state),
    isGreyedOut: selectors.getIsScreenGreyedOut(state),
    isDataFetched: selectors.getIsDazeDataFetched(state),
    paragraphs: selectors.getDazeParagraphs(state, MODEL),
    questions: selectors.getDazeQuestionItems(state, MODEL),
    title: selectors.getDazeTitle(state, MODEL),
    selectedResponses: selectors.getDazeSelectedResponses(state),
});

const mapDispatchToProps = (dispatch) => ({
    fetchContent: () => {
        dispatch(fetchDazeContent());
    },
    narrateScreen: () => {
        dispatch(greyOutScreen());
        dispatch(blockScreen());
        return dispatch(playDirectionsScript())
            .then(() => {
                dispatch(setAvatarInstructions(INSTRUCTIONS.modelIncorrectResponse));
                dispatch(colorInScreen());
                return dispatch(playModelScript());
            }).then(() => {
                dispatch(unblockScreen());
            });
    },
    onResponseSelected: (questionId, responseId) => {
        dispatch(onResponseSelected(questionId, responseId));
    },
    cleanup: () => {
        dispatch(stopAudio());
        dispatch(clearResponses());
        dispatch(unmountScreen());
    },
    onNext: () => {
        dispatch(goToPractice(DAZE));
    },
});

const avatarMapStateToProps = () => ({
    position: AvatarView.Position.MIDDLE_LEFT,
});

const DazeModelContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(DazeModelView);

export default DazeModelContainer;
